// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiURL: "https://localhost:5001",
  //apiURL: "https://merlin-api20210312192915.azurewebsites.net",
  apiURL: "https://merlin.ekitabu.net",
  mapbox: {
    accessToken: 'pk.eyJ1IjoibXV0dGVyYmFjayIsImEiOiJja205ZG51emowcnYyMnVxZnJoamdveWR4In0.R9YTg-IwmUw3b-f-pf40Iw'
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
